export enum CriteriaStep {
  Issues,
  Contexts,
  Options,
}
